import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
// import ChangeDateForm from "./ChangeDateForm";

interface HeaderProps {
  id: string;
}

const TraineeReport: React.FC<HeaderProps> = ({ id }) => {
  const { openModal, closeModal, setTitle } = useSiteContext();
  const navigate = useNavigate();
  const [_data, setData] = useState<any>();

  const loadTableData = () => {
    let URL = SESSION_URLS.GET_TRAINEE_REPORT;
    let data_in = {
      session_user_id: id,
    };
    const subscription = post(URL, data_in).subscribe((response) => {
      setData(response.data);
      //setTitle("Trainee Report");
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
    setTitle("Loco Pilot Report");
  }, []);

  const questionsDisplay = (item: any) => {
    return (
      <div className="card mb-2">
        <div className="card-header has-text-link">
          <b>{item?.question_text}</b>
        </div>
        <div className="content">
          <div className="columns is-multiline">
            {item.options &&
              item.options.map((obj: any, index: number) => {
                let class_name = "";
                if (
                  item.selected_option_id > 0 &&
                  item.correct_option_id == obj.option_id
                ) {
                  class_name = "has-text-success";
                } else if (item.selected_option_id == obj.option_id) {
                  class_name = "has-text-danger";
                } else if (item.correct_option_id == obj.option_id) {
                  class_name = "has-text-info";
                }
                return (
                  <div className={`column is-6 ${class_name}`}>
                    {index + 1} {")"} {obj.option_text}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  if (_data?.ID == undefined) {
    return <></>;
  }

  return (
    <div className="">
      <table className="table is-fullwidth">
        <tr>
          <th>Name:</th>
          <td>{_data?.ename}</td>
          <th>Employee ID:</th>
          <td>{_data?.euserid}</td>
          <th>Mobile No:</th>
          <td>{_data?.mobile_no}</td>
        </tr>
        <tr>
          <th>Session ID:</th>
          <td>{_data?.session_id}</td>
          <th>Venue:</th>
          <td>{_data?.euserid}</td>
          <th>Loco Shed:</th>
          <td>{_data?.loco_shed}</td>
        </tr>
        <tr>
          <th>No Of Questions:</th>
          <td>{_data?.no_of_questions}</td>
          <th>Correct Answers:</th>
          <td>{_data?.correct_answers}</td>
          <th>Score:</th>
          <td>{_data?.score}</td>
        </tr>
      </table>
      {/** marks need to diplayed : total questions attended total correct .. status */}
      {_data?.questions.map((item: any) => {
        return (
          <>
            <div className="column">{questionsDisplay(item)}</div>
          </>
        );
      })}
    </div>
  );
};

export default TraineeReport;
